import type { CharacterIPMedia } from '../../components/CharacterIPPanel/types';

/** 试听仅使用音频字段，不把 preview 封面图当作可播放地址。 */
export function getMyIpTimbreMedia(raw: unknown): CharacterIPMedia | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const item = raw as Record<string, unknown>;
  try {
    const id = typeof item.id === 'number' && Number.isSafeInteger(item.id) ? String(item.id) : item.id;
    // 与服务端 uint64 身份一致，纯展示转换不能拉入请求层或损失整数精度。
    if (typeof id !== 'string' || !/^[1-9]\d*$/.test(id) || id.length > 20
      || (id.length === 20 && id > '18446744073709551615')) return null;
    const trial = item.trial_file as { url?: unknown; } | undefined;
    const source = typeof trial?.url === 'string' && trial.url ? trial.url : item.url;
    let url = '';
    if (typeof source === 'string' && source) {
      const parsed = new URL(source);
      if (['http:', 'https:'].includes(parsed.protocol) && !parsed.username && !parsed.password) url = source;
    }
    if (typeof item.voice_id !== 'number' || !Number.isSafeInteger(item.voice_id)
      || typeof item.channel !== 'string' || !item.channel
      || typeof item.ext_voice_id !== 'string') return null;
    const name = typeof item.name === 'string' && item.name ? item.name : item.default_name;
    if (typeof name !== 'string' || !name) return null;
    return {
      id,
      name,
      url,
      kind: 'audio',
      timbre: {
        id,
        name,
        voice_id: item.voice_id,
        channel: item.channel,
        ext_voice_id: item.ext_voice_id,
        trial_file: { url },
      },
    };
  } catch { return null; }
}
